import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  FormHelperText,
  TextField,
  InputAdornment,
  Autocomplete,
  FormLabel,
  Dialog,
  DialogContent,
  FormControlLabel,
  Checkbox,
  Divider,
  Tooltip,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import DataContext from "../../context/DataContext";
import HomeIcon from "@mui/icons-material/Home";
import SchoolIcon from "@mui/icons-material/School";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ForumIcon from "@mui/icons-material/Forum";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import VillaIcon from "@mui/icons-material/Villa";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import apiService from "../../api/apiService";

const tamilNaduData = [
  {
    district: "Chennai",
    taluks: [
      {
        taluk: "Chennai Central",
        areaTypes: [
          {
            areaType: "Corporation",
            villages: ["T. Nagar", "Mylapore", "Anna Nagar"],
          },
          {
            areaType: "Town",
            villages: ["Kodambakkam", "Nungambakkam"],
          },
        ],
      },
    ],
  },
  {
    district: "Coimbatore",
    taluks: [
      {
        taluk: "Coimbatore North",
        areaTypes: [
          {
            areaType: "Municipality",
            villages: ["Gandhipuram", "RS Puram"],
          },
          {
            areaType: "Rural",
            villages: ["Perur", "Kurichi"],
          },
        ],
      },
      {
        taluk: "Coimbatore South",
        areaTypes: [
          {
            areaType: "Town",
            villages: ["Peelamedu", "Sitra"],
          },
        ],
      },
    ],
  },
  {
    district: "Madurai",
    taluks: [
      {
        taluk: "Madurai East",
        areaTypes: [
          {
            areaType: "Corporation",
            villages: ["Koodal Nagar", "Simmakkal"],
          },
          {
            areaType: "Rural",
            villages: ["Thiruparankundram", "Alanganallur"],
          },
        ],
      },
    ],
  },
];
const communities = ["General", "BC", "OBC", "SC", "ST"];
const educationList = [
  "No formal education",
  "Primary education",
  "Secondary education or high school",
  "Diploma",
  "Bachelor's degree",
  "Master's degree",
  "Doctorate or higher",
];
const memberOfList = ["Scouts", "Others Specify"];
const areaOfInterestList = [
  "Community Service",
  "Clean Environment",
  "Health",
  "Education & Skill Training",
  "Sports",
  "Arts & Culture",
];
const districts = [
  { id: 1, name: "Chennai" },
  { id: 2, name: "Coimbatore" },
  { id: 3, name: "Madurai" },
  { id: 4, name: "Trichy" },
  { id: 5, name: "Tirunelveli" },
  { id: 6, name: "Salem" },
  { id: 7, name: "Erode" },
  { id: 8, name: "Vellore" },
  { id: 9, name: "Kanchipuram" },
  { id: 10, name: "Thanjavur" },
  { id: 11, name: "Tiruppur" },
  { id: 12, name: "Kumarakom" },
  { id: 13, name: "Villupuram" },
  { id: 14, name: "Dindigul" },
  { id: 15, name: "Cuddalore" },
  { id: 16, name: "Nagapattinam" },
  { id: 17, name: "Perambalur" },
  { id: 18, name: "Pudukkottai" },
  { id: 19, name: "Karur" },
  { id: 20, name: "Sivaganga" },
];
const today = dayjs();
const minAllowedDate = today.subtract(30, "year"); // Maximum age 30
const maxAllowedDate = today.subtract(18, "year"); // Minimum age 18
const Register = () => {
  const { validatePhoneNumber, VisuallyHiddenInput, navigator } =
    useContext(DataContext);
  const [date, setDate] = useState(null);

  const [taluks, setTaluks] = useState([]);
  const [age, setAge] = useState(null);
  const [open, setOpen] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
    getValues,
    clearErrors,
  } = useForm({ values: {}, mode: "onBlur" });
  const sportsPlayer = watch("sportsPlayer", false);
  const traditionalArt = watch("traditionalArt", false);
  // const memberOf = watch("memberOf", "");
  const computerSkill = watch("computerSkill", false);
  useEffect(() => {
    const phone = sessionStorage.getItem("phone");
    if (phone) {
      setValue("phone", phone);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };
  const handleGender = (val) => {
    setValue("gender", val);
  };
  const handleDistrictChange = (district) => {
    if (district) {
      const districtData = tamilNaduData.find((d) => d.district === district);
      setTaluks(districtData ? districtData.taluks : []);
    }
    // Reset dependent fields
    setValue("taluk", null);
    setValue("areaType", null);
    setValue("village", null);

    // Clear validation errors
    clearErrors("taluk");
    clearErrors("areaType");
    clearErrors("village");
  };
  const handleFileUpload = (event, filekey, fileName, fileUrl) => {
    let logoselecetdFile = "";
    if (event !== null) {
      if (event.target === undefined) {
        logoselecetdFile = event;
      } else {
        logoselecetdFile = event.target.files[0];
      }

      const maxFileSize = 5 * 1024 * 1024; // 5MB in bytes
      if (logoselecetdFile) {
        if (logoselecetdFile.size < maxFileSize) {
          var reader = new FileReader();
          var imagetype = logoselecetdFile.type;
          var imagedatatype = imagetype.split("/");
          var img_crt_type = imagedatatype[1];
          if (
            img_crt_type === "jpg" ||
            img_crt_type === "png" ||
            img_crt_type === "jpeg"
          ) {
            setValue(filekey, "");
            setValue(fileName, "");
            setValue(fileUrl, "");
            var fileValue = logoselecetdFile;
            reader.readAsDataURL(logoselecetdFile);
            reader.onload = () => {
              var logourl1 = reader.result;
              var spl = logourl1.split(",");
              var ImageValue = spl[1];
              var img_name = fileValue.name;
              setValue(filekey, ImageValue);
              setValue(fileName, img_name);
              setValue(fileUrl, logourl1);
              clearErrors(filekey);
              clearErrors(fileName);
            };
          } else {
            // Handle invalid file type
          }
        } else {
          // Handle file size exceeding the limit
        }
      }
    }
  };
  const handleDateChange = (newValue) => {
    setDate(newValue);
    setValue("dob", newValue);
    clearErrors("dob");
  };
  const onSubmit = (data) => {
    const formattedData = {
      name: data.name,
      dob: dayjs(data.dob).format("YYYY-MM-DD"), // Format date correctly
      age: calculateAge(data.dob),
      gender: data.gender,
      fatherName: data.fatherName || "", // Assuming you have a fatherName field
      education: data.education || "", // Assuming education is a field in your form
      address: data.address || "", // Assuming address is a field
      district: data.district,
      areaType: data.areaType || "",
      taluk: data.taluk,
      village: data.village || "", // Assuming village is a field
      phone: data.phone || "", // Assuming phone number is collected
      email: data.email,
      community: data.community || "General", // Assuming a default community
      differentlyAbled: data.differentlyAbled || false,
      // memberOf: data.memberOf || "",
      // memberOfOther: data.memberOfOther || "",
      sportsPlayer: data.sportsPlayer || false,
      sport: data.sport || "",
      traditionalArt: data.traditionalArt || false,
      artName: data.artName || null,
      artisian: data.artisian || false,
      writer: data.writer || false,
      speaker: data.speaker || false,
      socialWorker: data.socialWorker || false,
      certLibrarian: data.certLibrarian || false,
      computerSkill: data.computerSkill || false,
      scout: data.scout || false,
      nss: data.nss || false,
      ncc: data.ncc || false,
      areaOfInterest: data.areaOfInterest || "",
      image: data.image || "", // Convert uploaded image to base64
      imageName: data.imageName || "",
      computerSkillName: data.computerSkillName || "",
    };

    console.log("Formatted Data:", formattedData);
    apiService("user/register", formattedData, "unauthpost")
      .then((result) => {
        if (result?.data?.responseStatus === "Success") {
          setOpen(true);
        }
      })
      .catch((err) => {});
  };
  const onError = (event) => {};

  const handleClose = () => {
    setOpen(false);
    navigator("/");
  };
  return (
    <div className="login-page pt-3">
      <div className="container-fluid">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-5 col-md-5 col-12 mb-3">
            <div class="login100-pic text-center" data-tilt>
              <img
                src="/images/YF_transparent.png"
                alt="IMG"
                className="img-fluid logo-img"
              />
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-12">
            <form
              className="login-form validate-form"
              onSubmit={handleSubmit(onSubmit, onError)}
            >
              <h3 className="login100-form-title mb-5">Register Now</h3>
              <div>
                <p>
                  <b>Personal Details</b>
                </p>
                <Divider className="mb-4" />
                <div className="row">
                  <div className="col-lg-9 col-md-8 col-12">
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="form-group">
                          <Controller
                            name="name"
                            control={control}
                            defaultValue=""
                            rules={{ required: "Name is required" }}
                            render={({ field }) => (
                              <TextField
                                variant="outlined"
                                label="Name *"
                                placeholder="Enter Name"
                                fullWidth
                                type="text"
                                {...field}
                                error={!!errors.name}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <PersonIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.name?.message}
                          </FormHelperText>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="form-group">
                          <Controller
                            name="email"
                            control={control}
                            defaultValue=""
                            rules={{ required: false }}
                            render={({ field }) => (
                              <TextField
                                variant="outlined"
                                label="Email Id"
                                placeholder="Enter Email Id"
                                fullWidth
                                type="text"
                                {...field}
                                error={!!errors.email}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <EmailIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.email?.message}
                          </FormHelperText>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="form-group">
                          <Controller
                            name="phone"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: "Mobile Number is required",
                              validate: validatePhoneNumber,
                            }}
                            render={({ field }) => (
                              <TextField
                                variant="outlined"
                                label="Mobile Number *"
                                placeholder="Enter Mobile Number"
                                fullWidth
                                type="text"
                                {...field}
                                error={!!errors.phone}
                                inputProps={{ maxLength: 10, readOnly: true }}
                                helperText={errors.phone?.message}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <PhoneIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="form-group">
                          <Controller
                            name="dob"
                            control={control}
                            rules={{ required: "DOB is required" }}
                            render={({ field }) => (
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="DOB"
                                  format="DD/MM/YYYY"
                                  disableFuture
                                  minDate={minAllowedDate}
                                  maxDate={maxAllowedDate}
                                  value={date}
                                  {...field}
                                  sx={{ width: "100%" }}
                                  onChange={(newValue) => {
                                    handleDateChange(newValue);
                                    field.onChange(newValue);
                                    setAge(calculateAge(newValue));
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      error={!!errors.dob}
                                      helperText={errors.dob?.message}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.dob && errors.dob.message}
                          </FormHelperText>
                          {age !== null && (
                            <FormHelperText
                              className="text-info"
                              sx={{ float: "right", fontSize: "14px" }}
                            >
                              Age: {age}
                            </FormHelperText>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="form-group">
                          <Controller
                            name="fatherName"
                            control={control}
                            defaultValue=""
                            rules={{
                              required:
                                "Father/Mother/Guardian Name is required",
                            }}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Father/Mother/Guardian Name *"
                                fullWidth
                                placeholder="Enter Father/Mother/Guardian Name"
                                error={!!errors.fatherName}
                                helperText={errors.fatherName?.message}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <PersonIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <FormLabel>
                          Gender <span className="text-danger">*</span>
                        </FormLabel>
                        <Controller
                          name={`gender`}
                          control={control}
                          defaultValue=""
                          rules={{ required: "Gender is required" }} // Display custom error message
                          render={({ field }) => (
                            <div className="p-relative gender_input">
                              <Tooltip title="Male" placement="top">
                                <span
                                  className={
                                    getValues(`gender`) === "Male"
                                      ? "genderspan genderAct"
                                      : "genderspan"
                                  }
                                  onClick={() => {
                                    handleGender("Male");
                                    field.onChange("Male"); // Make sure the controller field gets updated
                                  }}
                                >
                                  <img
                                    src="/images/male.png"
                                    className="sml_img"
                                    alt="Male"
                                  />
                                </span>
                              </Tooltip>
                              <Tooltip title="Female" placement="top">
                                <span
                                  className={
                                    getValues(`gender`) === "Female"
                                      ? "genderspan genderAct"
                                      : "genderspan"
                                  }
                                  onClick={() => {
                                    handleGender("Female");
                                    field.onChange("Female"); // Make sure the controller field gets updated
                                  }}
                                >
                                  <img
                                    src="/images/female.png"
                                    className="sml_img"
                                    alt="Female"
                                  />
                                </span>
                              </Tooltip>
                              <Tooltip title="Transgender" placement="top">
                                <span
                                  className={
                                    getValues(`gender`) === "Trans"
                                      ? "genderspan genderAct"
                                      : "genderspan"
                                  }
                                  onClick={() => {
                                    handleGender("Trans");
                                    field.onChange("Trans"); // Make sure the controller field gets updated
                                  }}
                                >
                                  <img
                                    src="/images/trang.png"
                                    className="sml_img"
                                    alt="Trans"
                                  />
                                </span>
                              </Tooltip>
                            </div>
                          )}
                        />
                        <FormHelperText className="text-danger">
                          {errors.gender?.message && `Gender is required`}
                        </FormHelperText>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-12">
                    <div className="form-group mt-2 text-center">
                      <div className="logo_div">
                        <img
                          src={
                            getValues("imageUrl")
                              ? getValues("imageUrl")
                              : "./images/user.png"
                          }
                          className="user_logo"
                          alt={getValues("imageName")}
                        />
                        <div className="camera_icon">
                          <Button
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                "image",
                                "imageName",
                                "imageUrl"
                              )
                            }
                            component="label"
                            startIcon={<CameraAltIcon />}
                          >
                            <VisuallyHiddenInput type="file" />
                          </Button>
                        </div>
                      </div>
                      <div>
                        <span>
                          Profile Image <span className="text-danger">*</span>
                        </span>
                      </div>
                      <div>
                        <span className="fn-12">
                          Recommend Size (128px * 128px)
                        </span>
                      </div>
                      <div>
                        <span className="fn-12">
                          Maximum 5 mb allowed doc (png, jpg, jpeg){" "}
                          <span className="text-danger">*</span>
                        </span>
                      </div>
                      {/* {logoInvalid === true ? (
                        <span className="text-danger">
                          Startup Logo is required
                        </span>
                      ) : (
                        <></>
                      )} */}
                      <div>
                        <Controller
                          name="imageName"
                          control={control}
                          defaultValue=""
                          rules={{ required: "Image is required" }}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Upload Image"
                              variant="outlined"
                              fullWidth
                              error={Boolean(errors.imageName)}
                              helperText={
                                errors.imageName && errors.imageName.message
                              }
                              className="d-none"
                            />
                          )}
                        />
                        <FormHelperText className="text-danger text-center">
                          {errors.imageName && `Profile Image is required`}
                        </FormHelperText>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <p>
                  <b>Address Details</b>
                </p>
                <Divider className="mb-4" />
                <div className="row">
                  <div className="col-lg-3 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="address"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Address is required" }}
                        render={({ field }) => (
                          <TextField
                            variant="outlined"
                            label="Address *"
                            placeholder="Enter Address"
                            fullWidth
                            type="text"
                            {...field}
                            error={!!errors.address}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <ImportContactsIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      />
                      <FormHelperText className="text-danger">
                        {errors.address?.message}
                      </FormHelperText>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="district"
                        control={control}
                        rules={{ required: "District is required" }}
                        render={({ field }) => (
                          <Autocomplete
                            disableClearable
                            {...field}
                            options={districts.map((district) => district.name)}
                            onChange={(_, value) => {
                              field.onChange(value);
                              handleDistrictChange(value); // Handle district change
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="District *"
                                variant="outlined"
                                fullWidth
                                error={!!errors.district}
                                helperText={errors.district?.message}
                                placeholder="Select District"
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <LocationCityIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="taluk"
                        control={control}
                        rules={{ required: "Block is required" }}
                        render={({ field }) => (
                          <Autocomplete
                            disableClearable
                            {...field}
                            options={taluks.map((t) => t.taluk)}
                            value={
                              field.value &&
                              taluks.some((t) => t.taluk === field.value)
                                ? field.value
                                : null
                            } // Ensure valid value
                            onChange={(_, value) => {
                              field.onChange(value);
                              setValue("areaType", null, {
                                shouldValidate: true,
                              }); // Reset area type when taluk changes
                              clearErrors("areaType");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Block *"
                                variant="outlined"
                                fullWidth
                                error={!!errors.taluk}
                                helperText={errors.taluk?.message}
                                placeholder="Select Block"
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <LocationOnIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="areaType"
                        control={control}
                        rules={{ required: "Area Type is required" }}
                        render={({ field }) => (
                          <Autocomplete
                            disableClearable
                            {...field}
                            options={
                              taluks
                                .find((t) => t.taluk === getValues("taluk"))
                                ?.areaTypes.map((a) => a.areaType) || []
                            }
                            value={
                              field.value &&
                              taluks
                                .find((t) => t.taluk === getValues("taluk"))
                                ?.areaTypes.some(
                                  (a) => a.areaType === field.value
                                )
                                ? field.value
                                : null
                            } // Ensure valid value
                            onChange={(_, value) => {
                              field.onChange(value);
                              setValue("village", null, {
                                shouldValidate: true,
                              }); // Reset village when area type changes
                              clearErrors("village");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Area Type *"
                                variant="outlined"
                                fullWidth
                                error={!!errors.areaType}
                                helperText={errors.areaType?.message}
                                placeholder="Select Area Type"
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <VillaIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="village"
                        control={control}
                        rules={{ required: "Village / Ward No is required" }}
                        render={({ field }) => (
                          <Autocomplete
                            disableClearable
                            {...field}
                            options={
                              taluks
                                .find((t) => t.taluk === getValues("taluk"))
                                ?.areaTypes.find(
                                  (a) => a.areaType === getValues("areaType")
                                )?.villages || []
                            }
                            value={
                              field.value &&
                              taluks
                                .find((t) => t.taluk === getValues("taluk"))
                                ?.areaTypes.find(
                                  (a) => a.areaType === getValues("areaType")
                                )
                                ?.villages.includes(field.value)
                                ? field.value
                                : null
                            } // Ensure valid value
                            onChange={(_, value) => field.onChange(value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Village / Ward No *"
                                variant="outlined"
                                fullWidth
                                error={!!errors.village}
                                helperText={errors.village?.message}
                                placeholder="Select Village / Ward No"
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <HomeIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <p>
                  <b>Additional Details</b>
                </p>
                <Divider className="mb-4" />
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="education"
                        control={control}
                        defaultValue=""
                        rules={{
                          required: "Education is required",
                        }}
                        render={({ field }) => (
                          <Autocomplete
                            disableClearable
                            options={educationList}
                            onChange={(_, value) => field.onChange(value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Education *"
                                fullWidth
                                placeholder="Select Education"
                                error={!!errors.education}
                                helperText={errors.education?.message}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SchoolIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="community"
                        control={control}
                        defaultValue=""
                        rules={{
                          required: "Community is required",
                        }}
                        render={({ field }) => (
                          <Autocomplete
                            disableClearable
                            options={communities}
                            onChange={(_, value) => field.onChange(value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Community *"
                                fullWidth
                                placeholder="Select Community"
                                error={!!errors.community}
                                helperText={errors.community?.message}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <ForumIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="areaOfInterest"
                        control={control}
                        defaultValue={[]} // Ensure it's an array for multiple selection
                        rules={{
                          required: "Area of Interest is required",
                        }}
                        render={({ field }) => (
                          <Autocomplete
                            disableClearable
                            {...field}
                            options={
                              Array.isArray(areaOfInterestList)
                                ? areaOfInterestList
                                : []
                            }
                            multiple
                            value={field.value || []} // Ensure value is always an array
                            onChange={(_, value) => field.onChange(value)} // Update React Hook Form state
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Area of Interest *"
                                variant="outlined"
                                fullWidth
                                error={!!errors.areaOfInterest}
                                helperText={errors.areaOfInterest?.message}
                                placeholder="Select Area of Interest"
                                // InputProps={{
                                //   ...params.InputProps,
                                //   startAdornment: (
                                //     <InputAdornment position="start">
                                //       <HomeIcon />
                                //     </InputAdornment>
                                //   ),
                                // }}
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  {/* <div className="col-lg-3 col-md-4 col-12">
                    <div className="form-group">
                      <Controller
                        name="memberOf"
                        control={control}
                        defaultValue=""
                        rules={{
                          required: "Required",
                        }}
                        render={({ field }) => (
                          <Autocomplete
                            disableClearable
                            {...field}
                            options={memberOfList}
                            onChange={(_, value) => {
                              field.onChange(value);
                              value !== "Others Specify" &&
                                setValue("memberOfOther", "");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="During School/College Days are you member of *"
                                variant="outlined"
                                fullWidth
                                error={!!errors.memberOf}
                                helperText={errors.memberOf?.message}
                                placeholder="Select During School/College Days are you member of"
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div> */}

                  {/* {memberOf === "Others Specify" && (
                    <div className="col-lg-3 col-md-4 col-12">
                      <div className="form-group">
                        <Controller
                          name="memberOfOther"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: "Member Of Other Required",
                          }}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Member Of Other *"
                              fullWidth
                              error={!!errors.memberOfOther}
                              helperText={errors.memberOfOther?.message}
                            />
                          )}
                        />
                      </div>
                    </div>
                  )} */}
                  <div className="col-lg-12 col-md-12 col-12">
                    <div className="row justify-content-start">
                      <div className="col-lg-2 col-md-3 col-12 text-center checkbox-dev">
                        <div>
                          <Controller
                            name="differentlyAbled"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("differentlyAbled")
                                      ? "/images/register/differently-act.jpeg"
                                      : "/images/register/differently.jpeg"
                                  }
                                  alt="Differently_Abled"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    // setDifferentlyAbled(
                                    //   (prevState) => !prevState
                                    // );
                                    setValue("differentlyAbled", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Differently Abled ?</p>
                      </div>
                      <div className="col-lg-2 col-md-3 col-12 text-center">
                        <div>
                          <Controller
                            name="artisian"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("artisian")
                                      ? "/images/register/artisan-act.jpg"
                                      : "/images/register/artisan.jpeg"
                                  }
                                  alt="artisian"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    // setDifferentlyAbled(
                                    //   (prevState) => !prevState
                                    // );
                                    setValue("artisian", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Artisian ?</p>
                      </div>
                      <div className="col-lg-2 col-md-3 col-12 text-center">
                        <div>
                          <Controller
                            name="writer"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("writer")
                                      ? "/images/register/writer-act.jpg"
                                      : "/images/register/writer.jpg"
                                  }
                                  alt="writer"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setValue("writer", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Writer ?</p>
                      </div>
                      <div className="col-lg-2 col-md-3 col-12 text-center">
                        <div>
                          <Controller
                            name="speaker"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("speaker")
                                      ? "/images/register/speaker-act.jpg"
                                      : "/images/register/speaker.jpg"
                                  }
                                  alt="speaker"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setValue("speaker", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Speaker ?</p>
                      </div>
                      <div className="col-lg-2 col-md-3 col-12 text-center">
                        <div>
                          <Controller
                            name="socialWorker"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("socialWorker")
                                      ? "/images/register/worker-act.jpeg"
                                      : "/images/register/worker.jpeg"
                                  }
                                  alt="socialWorker"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setValue("socialWorker", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Social Worker ?</p>
                      </div>
                      <div className="col-lg-2 col-md-3 col-12 text-center">
                        <div>
                          <Controller
                            name="certLibrarian"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("certLibrarian")
                                      ? "/images/register/librarian-act.jpg"
                                      : "/images/register/librarian.jpeg"
                                  }
                                  alt="certLibrarian"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setValue("certLibrarian", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Certified Librarian ?</p>
                      </div>
                      <div className="col-lg-2 col-md-3 col-12 text-center">
                        <div>
                          <Controller
                            name="computerSkill"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("computerSkill")
                                      ? "/images/register/software-act.png"
                                      : "/images/register/software.png"
                                  }
                                  alt="computerSkill"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setValue("computerSkill", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Computer Skill ?</p>
                        {computerSkill && (
                          <div className="form-group">
                            <Controller
                              name="computerSkillName"
                              control={control}
                              defaultValue=""
                              rules={{
                                required: "Computer Skill Name is required",
                              }}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  label="Computer Skill Name *"
                                  placeholder="Enter Computer Skill Name"
                                  error={!!errors.computerSkillName}
                                  helperText={errors.computerSkillName?.message}
                                  fullWidth
                                />
                              )}
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-lg-2 col-md-3 col-12 text-center">
                        <div>
                          <Controller
                            name="sportsPlayer"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("sportsPlayer")
                                      ? "/images/register/sports-act.jpeg"
                                      : "/images/register/sports.jpeg"
                                  }
                                  alt="sportsPlayer"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setValue("sportsPlayer", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Sports Player ?</p>
                        {sportsPlayer && (
                          <div className="form-group">
                            <Controller
                              name="sport"
                              control={control}
                              defaultValue=""
                              rules={{
                                required: "Sport Name is required",
                              }}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  label="Sport Name *"
                                  placeholder="Enter Sport Name"
                                  error={!!errors.sport}
                                  helperText={errors.sport?.message}
                                  fullWidth
                                />
                              )}
                            />
                          </div>
                        )}
                      </div>
                      <div className="col-lg-2 col-md-3 col-12 text-center">
                        <div>
                          <Controller
                            name="traditionalArt"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <Tooltip title="Click to select" placement="top">
                                <img
                                  {...field}
                                  src={
                                    getValues("traditionalArt")
                                      ? "/images/register/traditional-act.jpeg"
                                      : "/images/register/traditional.jpeg"
                                  }
                                  alt="traditionalArt"
                                  className="physically_disable"
                                  style={{
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setValue("traditionalArt", !field.value);
                                  }}
                                />
                              </Tooltip>
                            )}
                          />
                        </div>
                        <p>Traditional Art ?</p>
                        {traditionalArt && (
                          <div className="form-group">
                            <Controller
                              name="artName"
                              control={control}
                              defaultValue=""
                              rules={{
                                required: "Art Name is required",
                              }}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  label="Art Name *"
                                  fullWidth
                                  placeholder="Enter Art Name"
                                  error={!!errors.artName}
                                  helperText={errors.artName?.message}
                                />
                              )}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12 col-12 my-3">
                    <div>
                      <p>
                        <b>During School/College Days are you member of ?</b>
                      </p>
                      {/* <Divider className="mb-4" /> */}
                      <div className="row justify-content-start">
                        <div className="col-lg-2 col-md-3 col-12 text-center">
                          <div>
                            <Controller
                              name="scout"
                              control={control}
                              defaultValue={false}
                              render={({ field }) => (
                                <Tooltip
                                  title="Click to select"
                                  placement="top"
                                >
                                  <img
                                    {...field}
                                    src={
                                      getValues("scout")
                                        ? "/images/register/scout-act.png"
                                        : "/images/register/scout.png"
                                    }
                                    alt="scout"
                                    className="physically_disable"
                                    style={{
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setValue("scout", !field.value);
                                    }}
                                  />
                                </Tooltip>
                              )}
                            />
                          </div>
                          <p>Scout & Guide ?</p>
                        </div>
                        <div className="col-lg-2 col-md-3 col-12 text-center">
                          <div>
                            <Controller
                              name="nss"
                              control={control}
                              defaultValue={false}
                              render={({ field }) => (
                                <Tooltip
                                  title="Click to select"
                                  placement="top"
                                >
                                  <img
                                    {...field}
                                    src={
                                      getValues("nss")
                                        ? "/images/register/ncc-act.png"
                                        : "/images/register/ncc.png"
                                    }
                                    alt="nss"
                                    className="physically_disable"
                                    style={{
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setValue("nss", !field.value);
                                    }}
                                  />
                                </Tooltip>
                              )}
                            />
                          </div>
                          <p>NSS ?</p>
                        </div>
                        <div className="col-lg-2 col-md-3 col-12 text-center">
                          <div>
                            <Controller
                              name="ncc"
                              control={control}
                              defaultValue={false}
                              render={({ field }) => (
                                <Tooltip
                                  title="Click to select"
                                  placement="top"
                                >
                                  <img
                                    {...field}
                                    src={
                                      getValues("ncc")
                                        ? "/images/register/nss-act.png"
                                        : "/images/register/nss.png"
                                    }
                                    alt="ncc"
                                    className="physically_disable"
                                    style={{
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setValue("ncc", !field.value);
                                    }}
                                  />
                                </Tooltip>
                              )}
                            />
                          </div>
                          <p>NCC ?</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <p>
                  <b>Declaration</b>
                </p>
                <Divider className="mb-4" />
                <div className="d-flex align-items-start">
                  <Controller
                    name="declaration"
                    control={control}
                    defaultValue={false}
                    rules={{
                      required: "Required",
                    }}
                    render={({ field }) => (
                      <FormControlLabel
                        control={<Checkbox {...field} checked={field.value} />}
                        label=""
                      />
                    )}
                  />
                  <div>
                    <p>
                      I hereby declare that the information provided in this
                      application form is true, complete, and accurate to the
                      best of my knowledge and belief. I understand that any
                      false statement, misrepresentation, or omission of facts
                      may lead to the rejection of my application or
                      disciplinary action.
                    </p>
                    <p>
                      I agree to abide by the rules, regulations, and terms set
                      forth by Youth Forum and provide any additional
                      documentation if required.
                    </p>
                  </div>
                </div>
                <FormHelperText className="text-danger">
                  {errors.declaration && errors.declaration.message}
                </FormHelperText>
                <p>
                  <b>Disclaimer</b>
                </p>
                <Divider className="mb-4" />
                <div className="d-flex align-items-start">
                  <div>
                    <p>
                      This application form is for submission purposes only and
                      does not guarantee approval. All applications are subject
                      to review and assessment based on the criteria set by
                      Youth Forum. Submission of this form does not constitute
                      an agreement, acceptance, or entitlement to any service,
                      benefit, or position.
                    </p>
                    <p>
                      Youth Forum reserves the right to approve, reject, or
                      request additional information at its discretion. The
                      final decision will be communicated to the applicant upon
                      completion of the review process.
                    </p>
                  </div>
                </div>
                <FormHelperText className="text-danger">
                  {errors.disclaimer && errors.disclaimer.message}
                </FormHelperText>
              </div>
              <div className="text-center">
                <Button
                  onClick={handleClose}
                  variant="contained"
                  color="primary"
                  sx={{
                    mt: 2,
                    mr: 2,
                    py: 1.5,
                    textTransform: "none",
                    background: "#dd1818",
                    "&:hover": { background: "#000", color: "#fff" },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{
                    mt: 2,
                    py: 1.5,
                    textTransform: "none",
                    background: "#28a745",
                    "&:hover": { background: "#000", color: "#fff" },
                  }}
                >
                  Register
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <div className="text-center">
            <img src={"/images/success.gif"} alt="" className="sucess-image" />
            <h4>Registeration Done..!!</h4>
            <Button variant="outlined" onClick={handleClose}>
              OK
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Register;

// ("memberOf");
// ("memberOfOther");
// ("artName");
